// extracted by mini-css-extract-plugin
module.exports =  {"cartSummaryContainer":"BaZNF","cartSummarySubContainer":"ZTfRO","section":"_1UAk2"};